import { Button, Grid, Typography } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import animationCongratulation from "../../../../../../../assets/animation/congratulations.json"
import Lottie from "react-lottie"
import { Timer } from "../../../../../../../components/timer"
import { useNavigate } from "react-router-dom"
import useAuth from "../../../../../../../context/auth"

interface Props {
    open: boolean,
    onClose: () => void
}

const referAndWinOptions = {
    loop: true,
    autoplay: true,
    animationData: animationCongratulation,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

export const ModalCongratulations = ({
    onClose,
    open
}: Props) => {
    const navigate = useNavigate()
    const { user } = useAuth()

    const createdAt = new Date(user?.actualContract?.contract?.integrations?.sign?.createdAt as string)
    const expirationTime = new Date(createdAt.getTime() + 24 * 60 * 60 * 1000) // 24 horas depois
    const timeRemaining = Math.max(0, Math.floor((expirationTime.getTime() - Date.now()) / 1000)) // Em segundos

    return (
        <ModalComponent
            open={open}
            withoutHeader
        >
            <Grid
                width={"100%"}
                display={"flex"}
                direction={"column"}
                gap={"1.7rem"}
                alignItems={"center"}
            >

                <div style={{ width: "25.2rem", height: 'auto', margin: "-7rem 0px -2rem 0px" }}>
                    <Lottie options={referAndWinOptions} />
                </div>

                <Typography fontWeight={700} fontSize={"3.2rem"}>Parabéns</Typography>

                <Typography fontSize={"1.4rem"} sx={{ opacity: .5 }} textAlign={"center"}>
                    Sua análise foi aprovada!
                    <br />
                    <br />
                    Agora só falta você assinar o contrato
                </Typography>

                <Button
                    variant="contained"
                    sx={{
                        width: "100%",
                        maxWidth: "27.5rem",
                        height: "4rem",
                        animation: "pulse 1.5s infinite"
                    }}
                    onClick={() => {
                        onClose()
                        navigate("/cliente/assinatura")
                    }}
                >Assinar contrato</Button>

                <Typography
                    fontWeight={700}
                    fontSize={"2rem"}
                    sx={{
                        opacity: .5
                    }}
                >
                    <Timer
                        hours={timeRemaining}
                    />
                </Typography>
            </Grid>
        </ModalComponent>
    )
}